import React from "react";
import ReactDOM from "react-dom/client";

import "./Styles/index.css";
import App from "./App";
import { UserProvider } from "./context/UserContext";
import { DataProvider } from "./context/DataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <DataProvider>
        <App />
      </DataProvider>
    </UserProvider>
  </React.StrictMode>
);
